<template>
    <div>
        <!-- Router View -->
        <router-view />
        
        <!-- Global Contact Form Popup -->
        <ContactFormPopup />
        
        <!-- Global cursor - NEVER gets destroyed -->
        <div class="element">
            <div class="element-item"></div>
        </div>
        
        <!-- Global share wrapper - NEVER gets destroyed -->
        <div class="share-wrapper">
            <div class="close-share-btn"><i class="fal fa-times"></i></div>
            <div class="share-container fl-wrap isShare"></div>
        </div>
        
        <!-- Global progress bar - NEVER gets destroyed -->
        <div class="progress-bar-wrap">
            <div class="progress-bar"></div>
        </div>
    </div>
</template>

<script>
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'
import ContactFormPopup from '@/components/ContactFormPopup.vue'

export default {
    name: 'Main',
    components: {
        ContactFormPopup
    },
    data() {
        return {
            isLoading: true,
            siteDefaultsStore: null
        }
    },
    async mounted() {
        this.siteDefaultsStore = useSiteDefaultsStore()
        
        // Load site defaults
        await this.siteDefaultsStore.loadSiteDefaults()
        
        // Initialize global theme scripts ONCE on app load
        if (this.$initTheme) {
            this.$initTheme()
        }
        
        // Hide preloader after everything is loaded
        setTimeout(() => {
            this.isLoading = false
            // Remove loader
            const loader = document.querySelector('.loader-wrap')
            if (loader) {
                loader.style.display = 'none'
            }
        }, 1500)

        // Listen for site defaults loaded event
        this.siteDefaultsStore.onSiteDefaultsLoaded((data) => {
            // Update document title
            if (data.siteName) {
                document.title = data.siteName
            }
            
            // Update meta description
            if (data.siteDescription) {
                const metaDescription = document.querySelector('meta[name="description"]')
                if (metaDescription) {
                    metaDescription.setAttribute('content', data.siteDescription)
                }
            }
        })
    },
    beforeUnmount() {
        if (this.siteDefaultsStore) {
            this.siteDefaultsStore.offAllEvents()
        }
    }
}
</script>
